import { Box, Typography } from '@mui/material';
import { PatientProfileInfoAccordionEditable } from './PatientProfileInfoAccordion';
import { useMemo } from 'react';
import { usePatientAllergiesQuery } from '@uplift/queries';
import { AllergiesForm } from '../../AllergiesForm/AllergiesForm.component';
import { updatePatientAllergies } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { useAlert } from '../../../../AlertProvider';

export type AllergiesAccordianProps = {
  patientId: string;
  editable: boolean;
  inlineForm?: boolean;
};

export type AllergiesFormType = {
  allergies: string[];
};

export const AllergiesAccordian: React.VFC<AllergiesAccordianProps> = ({ patientId, editable, inlineForm }) => {
  const l10n = useL10n();
  const alert = useAlert();
  const { data: allergies = [], refetch } = usePatientAllergiesQuery(patientId);

  const initialValues: AllergiesFormType = {
    allergies: allergies.map(allergy => allergy.name)
  };

  const onSubmit = async (values: AllergiesFormType) => {
    await updatePatientAllergies(patientId, values.allergies);

    await refetch();
  };

  const content = useMemo(() => {
    if (!allergies.length) {
      return <Typography variant="body2" color="textPrimary">{l10n.clientProfile.allergies.noAllergies}</Typography>;
    }

    return (
      <Box fontWeight={500}>
        <Typography variant="body2" color="textPrimary">
          {allergies.map((allergy) => allergy.name).join(', ')}
        </Typography>
      </Box>
    );
  }, [ allergies, l10n ]);

  return (
    <PatientProfileInfoAccordionEditable
      title="Allergies"
      editable={editable}
      inlineForm={inlineForm}
      formikConfig={{
        initialValues,
        onSubmit,
      }}
      form={<AllergiesForm />}
      onSuccess={(onCancelEdit) => {
        alert.success('Allergies updated');
        onCancelEdit();
      }}
    >
      {content}
    </PatientProfileInfoAccordionEditable>
  );
};
